import {useEffect, useState} from 'react';
import {Userpilot} from 'userpilot';
import {userpilotObject} from 'utils/userpilot-utils';
import {useStore} from 'hooks/useStore';
import {observer} from 'mobx-react';
import {COOKIE_PREFERENCE_OPTIONS} from 'enums';

const anonymousUserId = 'anonymous';

export const UserpilotTrigger = observer(({token, application}) => {
  const [userpilotUser, setUserpilotUser] = useState(null);

  const store = useStore();

  const {
    auth: {user, authing},
    router: {currentPath},
    cookiePreference: {cookiePreference},
    platform: {id, platformSlug, domain, loaded: platformLoaded}
  } = store;

  const userpilotEnabled = cookiePreference === COOKIE_PREFERENCE_OPTIONS.YES && !!token;

  const userId = user?.id;

  useEffect(() => {
    if (token) {
      Userpilot.initialize(token);
    }
  }, [token]);

  const userpilotParameters = userpilotObject({
    user,
    platform: {id, platformSlug, domain},
    application
  });

  useEffect(() => {
    if (!userpilotEnabled && userpilotUser) {
      Userpilot.destroy();
      setUserpilotUser(null);
    }
  }, [userpilotEnabled]);

  useEffect(() => {
    if (!userpilotEnabled) {
      return;
    }

    if (!platformLoaded || authing) {
      return;
    }

    const userId = user?.id ?? anonymousUserId;

    if (userpilotUser === userId) {
      return;
    }

    if (userId === anonymousUserId) {
      Userpilot.anonymous(userpilotParameters);
    } else {
      Userpilot.identify(userId, userpilotParameters);
    }
    setUserpilotUser(userId);
  }, [userId, platformLoaded, authing, userpilotUser, userpilotEnabled]);

  useEffect(() => {
    Userpilot.reload();
  }, [currentPath]);

  return null;
});
